<template>
    <el-dialog
        @close="closeDialog"
        class="leader-dialog"
        width="500px"
        :title="title"
        :show-close="true"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
    >
        <el-form
            class="leader-style-form"
            ref="unitForm"
            :model="unitForm"
            :rules="rules"
        >
            <el-form-item
                label="名称"
                label-width="100px"
                prop="tree_unit_name"
            >
                <el-input v-model="unitForm.tree_unit_name"></el-input>
            </el-form-item>
            <el-form-item
                label="能源分类"
                label-width="100px"
                prop="point_class_id"
            >
                <el-select
                    v-model="unitForm.point_class_id"
                    style="width: 100%"
                >
                    <el-option
                        v-for="item in areaTypeList"
                        :key="item.point_class_id"
                        :label="item.class_name"
                        :value="item.point_class_id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排序" label-width="100px" prop="seq">
                <el-input
                    v-model="unitForm.seq"
                    type="number"
                    maxlength="10"
                ></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
             <el-button
                size="small"
                class="leader-common-button"
                @click="saveUnit"
                >保存</el-button
            >
            <el-button
                size="small"
                class="leader-common-button"
                @click="dialogVisible = false"
                >取消</el-button
            > 
        </span>
    </el-dialog>
</template>
<script>
import * as api from "@/http/api.js";
export default {
    data() {
        return {
            unitForm: {
                tree_unit_name: "",
                point_class_id: "",
                seq: ""
            },
            areaTypeList: [],
            rules: {
                tree_unit_name: [
                    {
                        required: true,
                        message: "请输入名称",
                        trigger: "blur"
                    }
                ],
                point_class_id: [
                    {
                        required: true,
                        message: "请选择能源分类",
                        trigger: "change"
                    }
                ]
            }
        };
    },
    props: {
        dialogVisible: {
            type: Boolean
        },
        pUnitId: String,
        treeUnitId: String,
        treeUnitType: String,
        title: {
            type: String,
            default: "新增"
        },
        unitName: String,
        seq: String,
        pointsType: String,
        point_class_id: String
    },
    computed: {},
    watch: {
        dialogVisible(newVal) {
            if (newVal) {
                this.getCommonPointClassList();
                if (this.title == "修改") {
                    this.unitForm.tree_unit_name = this.unitName;
                    this.unitForm.point_class_id = this.point_class_id;
                    this.unitForm.seq = this.seq;
                }
            }
        }
    },
    methods: {
        closeDialog() {
            this.dialogVisible = false;
            this.$refs.unitForm.resetFields();
            this.$emit("update:dialogVisible", this.dialogVisible);
            this.$emit("closeCb");
        },
        getCommonPointClassList() {
            api.getCommonPointClassList().then(res => {
                if (res) {
                    this.areaTypeList = res.bus_json;
                }
            });
        },
        saveUnit() {
            this.$refs.unitForm.validate(valid => {
                if (valid) {
                    api.saveTreeUnit({
                        p_tree_unit_id: this.pUnitId,
                        tree_unit_id: this.treeUnitId,
                        ...this.unitForm,
                        tree_unit_type_id: this.treeUnitType
                    }).then(res => {
                        if (res && res.error_code == 0) {
                            this.$message({
                                message: res.error_msg,
                                type: "success"
                            });
                            this.closeDialog();
                        }
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss">
.access-control-dialog-2 {
    .el-input {
        width: auto;
    }
}
</style>
